import { createReducer, on } from '@ngrx/store';
import * as SquareRefundsActions from './square-refunds.actions';
import { SquareRefundListItem, SquareRefundTotals } from './square-refunds.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface SquareRefundsState {
    squareRefunds: SquareRefundListItem[];
    totalCount: number;
    totals: SquareRefundTotals | null;
    unlinkedRefunds: SquareRefundListItem[];
    unlinkedTotalCount: number;
    unlinkedTotals: SquareRefundTotals | null;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial State
// ----------------------------------------------------------------------

export const initialSquareRefundsState: SquareRefundsState = {
    squareRefunds: [],
    totalCount: 0,
    totals: null,
    unlinkedRefunds: [],
    unlinkedTotalCount: 0,
    unlinkedTotals: null,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducer
// ----------------------------------------------------------------------

export const squareRefundsReducer = createReducer(
    initialSquareRefundsState,

    // Load all
    on(SquareRefundsActions.loadSquareRefunds, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),
    on(SquareRefundsActions.loadSquareRefundsSuccess, (state, { squareRefunds, totalCount, totals }) => ({
        ...state,
        isLoading: false,
        squareRefunds,
        totalCount,
        totals,
    })),
    on(SquareRefundsActions.loadSquareRefundsFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    })),

    // Load unlinked refunds
    on(SquareRefundsActions.loadSquareUnlinkedRefunds, (state) => ({
        ...state,
        isLoading: true,
        error: null,
    })),
    on(SquareRefundsActions.loadSquareUnlinkedRefundsSuccess, (state, { unlinkedRefunds, totalCount, totals }) => ({
        ...state,
        isLoading: false,
        unlinkedRefunds,
        unlinkedTotalCount: totalCount,
        unlinkedTotals: totals,
    })),
    on(SquareRefundsActions.loadSquareUnlinkedRefundsFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error,
    }))
);
